import { type Widget } from '../../../Widget.ts';
import { engineWidgetCellId } from './expression/materializeTableInputWidget.ts';
import { type ITableWidgetCell, TableCellType } from './ITableCell.ts';
import { type ITableInputWidget } from './ITableInputWidget.ts';
import { isCustomRow } from './ITableRow.ts';
import { type ITableInputWidgetColumnsContext } from './render/useTableInputWidgetColumns.tsx';

/**
 * Ottiene il widget alla cella specificata, tenendo in considerazione che
 * possono esserci celle vuote e righe personalizzate con Widget dedicati.
 */
export function getTableWidgetAtCell(
  table: ITableInputWidget,
  context: ITableInputWidgetColumnsContext,
  rowIndex: number,
  columnIndex: number,
): Widget | undefined {
  const { columns, rows } = table;
  const { materializedWidgets } = context;
  const row = context.rows[rowIndex];
  const column = columns[columnIndex];

  if (isCustomRow(row)) {
    // Ci assicuriamo che sia di tipo Widget e che corrisponda alla colonna
    // attuale.
    const cell = row.cells.find(
      (c): c is ITableWidgetCell =>
        c.type === TableCellType.Widget && c.columnId === column.id,
    );

    return cell?.widget;
  }

  return materializedWidgets.find(
    w =>
      w.fromVirtualId === column.id &&
      w.id === engineWidgetCellId(table, row.id, column.id),
  );
}
